export default "__VITE_ASSET__168ddc09__"